// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var component = function (dictShow) {
    return function (dictEq) {
        return function (v) {
            var tabHtml = function (v1) {
                var currentTabClass = Data_Functor.voidRight(Data_Functor.functorArray)("tabs__tab--current")(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(Data_Eq.eq(dictEq)(v1.name)(v.currentTab)));
                var classes = Data_Semigroup.append(Data_Semigroup.semigroupArray)([ "tabs__tab" ])(currentTabClass);
                return Halogen_HTML_Elements.button([ Halogen_HTML_Properties.classes(Data_Functor.map(Data_Functor.functorArray)(Halogen_HTML_Core.ClassName)(classes)), Halogen_HTML_Events.onClick(Data_Function["const"](v.setTab(v1.name))) ])([ Halogen_HTML_Core.text(Data_Show.show(dictShow)(v1.name)) ]);
            };
            var maybeContent = Data_Foldable.find(Data_Foldable.foldableArray)(function (v1) {
                return Data_Eq.eq(dictEq)(v1.name)(v.currentTab);
            })(v.tabs);
            var header = (function () {
                var mkPiece = Data_Maybe.maybe([  ])(Control_Applicative.pure(Control_Applicative.applicativeArray));
                var start = mkPiece(v.headerStart);
                var end = mkPiece(v.headerEnd);
                return Data_Semigroup.append(Data_Semigroup.semigroupArray)(start)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Functor.map(Data_Functor.functorArray)(tabHtml)(v.tabs))(end));
            })();
            return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("tabs") ])([ Halogen_HTML_Elements.header([ Lunarbox_Component_Utils.className("tabs__header") ])(header), Halogen_HTML_Elements.main([ Lunarbox_Component_Utils.className("tabs__content") ])([ Lunarbox_Component_Utils.maybeElement(maybeContent)(function (v1) {
                return v1.content;
            }) ]) ]);
        };
    };
};
module.exports = {
    component: component
};
